export class ReportTemplate {
    constructor({
        id = null,
        userId = null,
        templateName = null,
        templateConfig = null,
        templateType = null,
        templateFile = null,
        templateFileName = null,
        excelTemplate = null,
        runtimeParam = null,
        dirPath = null,
        cronExpression = null,
        scheduleStatus = null,
    } = {}) {
        this.id = id;
        this.userId = userId;
        this.templateName = templateName;
        this.templateConfig = JSON.parse(templateConfig);
        this.templateType = templateType;
        this.templateFile = templateFile;
        this.templateFileName = templateFileName;
        this.excelTemplate = excelTemplate;
        this.runtimeParam = JSON.parse(runtimeParam);
        this.dirPath = dirPath;
        this.cronExpression = cronExpression;
        this.scheduleStatus = scheduleStatus;
    }
}
export function gridFields() {
    return Object.freeze([
        {
            key: 'templateName',
            label: 'report.template.templateName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'templateType',
            label: 'report.template.templateType',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'templateFileName',
            label: 'report.template.templateFileName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'dirPath',
            label: 'report.template.dirPath',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'scheduleStatus',
            label: 'report.template.isSchedule',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    { value: 1, text: '是' },
                    { value: 0, text: '否' }
                  ]
            }
        },
        {
            key: 'templateConfig',
            label: 'report.template.templateConfig',
            sortable: true,
            form: {
                type: 'reportConfig'
            }         
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new ReportTemplate()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.templateNameFilter',
    'filter.templateTypeFilter',
    'filter.templateFileNameFilter',
];

export const filter = {
    'templateNameFilter': "",
    'templateTypeFilter': "",
    'templateFileNameFilter': ""
};